import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
    suffixContainer: {
        display: "flex",
        alignItems: "center",
        gap: "2px",
        flexWrap: "nowrap",
        width: "100%",
        position: "relative",
    },
    textWrapper: {
        minWidth: 0,
        flex: "0 1 auto",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "calc(100% - 24px)",
    },
    iconWrapper: {
        flex: "0 0 auto",
        display: "inline-flex",
        alignItems: "center",
    },
});